import React , {useEffect} from 'react'
import ErrorPage from '../../Pages/ErrorPage'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Axios from "../../config/Axios"


function Errorforpackage() {
    const RandomAPI = async() => {
        var { data } = await Axios.get("https://api.redcliffelabs.com/api/v1/package/data/wrongurl/?city=xyz")
    }
    useEffect(() => {
        RandomAPI()
    }, [])
    return (
        <div>
            <Header/>
            <ErrorPage/>
            <Footer/>
        </div>
    )
}

export default {
    component: Errorforpackage,
  };